<script>
import cloneDeep from 'lodash/cloneDeep'
import { mapActions } from 'vuex'

const DESPACHO_EMPTY = {
  texto: null,
  documento: null,
  processoId: null,
  despachoId: null,
  acao: null
}

export default {
  data () {
    return { despacho: cloneDeep(DESPACHO_EMPTY), radioInicial: null }
  },

  methods: {
    ...mapActions({
      tarefa: 'processoArrecadacao/tarefa',
      findByIdProcesso: 'processoArrecadacao/findById'
    }),

    async init () {
      const idProcesso = this.$route.query.idProcesso || this.idProcesso
      if (idProcesso) {
        try {
          await this.setRadios(idProcesso)
          const response = await this.findByIdProcesso(idProcesso)
          this.processo = response
          this.setDespachos(response.despachos)
        } catch (e) {
          this.goToListagem()
        }
      } else if (this.$props.processoArrecadacao) {
        this.processo = cloneDeep(this.$props.processoArrecadacao)
        this.setDespachos(this.$props.processoArrecadacao.despachos)
      } else {
        this.goToListagem()
      }
    },

    async setRadios (idProcesso) {
      this.radios = await this.tarefa({ processo: idProcesso })
      this.radiosAcoes = this.radios.acoes
    },

    changeRadio (value) {
      this.radioInicial = value.acao
      this.despacho.acao = value.acao
    },

    showErroValidacao (
      message,
      tipo = this.$messages.TIPO_ERROR,
      titulo = this.$messages.TITULO_ERROR
    ) {
      this.showNotificacao(tipo, titulo, message)
    },

    setDespachos (despachos) {
      const despacho = despachos.find(despacho => despacho.isUltimo)
      this.historicoDespachos = despachos.filter(despacho => !despacho.isUltimo)
      if (despacho) {
        this.setDespacho(despacho)
        this.changeRadio(despacho)
      } else {
        this.despacho = cloneDeep(DESPACHO_EMPTY)
        this.despacho.processoId = this.processo.id
      }
    },

    setDespacho (despacho) {
      this.despacho = {
        ...this.despacho,
        texto: despacho.texto,
        documento: despacho.documento,
        processoId: this.processo.id,
        despachoId: despacho.id,
        acao: despacho.acao
      }
    },

    whitespace (field) {
      this.despacho[field] = this.despacho[field].trim()
    },

    goToListagem (routeFinalizar, query) {
      const rota = { name: routeFinalizar || this.$props.routeListagemName }
      rota.query = { ...query }
      if (this.$props.hasProcesso && !routeFinalizar) {
        rota.query = { idProcesso: this.processo?.id || this.idProcesso }
      }
      if (routeFinalizar || this.$props.routeListagemName) {
        this.$router.push({ ...rota })
      } else {
        this.$router.back()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/arrecadacao/mixins/BaseAnaliseProcessos.vue